/**
 * Notification
 */
class Notification {
    constructor(texts) {
        this.container =null
        this.noItems =null
        this.list =[]

        this.locked =false

        this.texts ={}
        this._value =''

        var that = this;
        this.texts = texts;
    }

    _lock() {
        this.locked = true;
    }

    _unlock() {
        this.locked = false;
    }

    _changeFriend(userId, status, callback, msg) {
        var that = this;
        that._lock();

        if (msg == undefined || !msg) {
            msg = this.texts.areYouSureRemove;
        }

        if (status) {
            $.ajax({
                url: "/profile/change-friend/", dataType: 'json', type: 'post',
                data: {user_id: userId, status: '1'},
                success: function(data) {
                    if (data && data.success != undefined && data.success) {
                        callback(data);
                        that._unlock();
                    } else that._unlock();
                }
            });
        } else {
            bootbox.confirm(msg, function(res) {
                if (!res) {
                    that._unlock();
                    return;
                }

                $.ajax({
                    url: "/profile/change-friend/", dataType: 'json', type: 'post',
                    data: {user_id: userId, status: '0'},
                    success: function(data) {
                        if (data && data.success != undefined && data.success) {
                            callback(data);
                            that._unlock();
                        } else that._unlock();
                    }
                });
            });
        }

    }

    friend(userId) {
        var that = this;
        this._changeFriend(userId, 1, function() {
            //$(".friendship-request-" + userId).remove(); //Should we remove it?
            $('.friendship-request-' + userId + ' fieldset').html('<a href="' + $('.friendship-request-' + userId + ' a:first').attr('href') + '">' + that.texts.openProfile + '</a><span>·</span><a href="#" onclick="window.evedo.sendMessage(' + userId + ', \'' + $('.friendship-request-' + userId + ' p strong:first').text() + '\')">' + that.texts.message + '</a>');

        });
    }

    rejectFriend(userId) {
        var that = this;

        this._changeFriend(userId, 0, function() {
            $(".friendship-request-" + userId).remove(); // SHould we remove it?
        }, that.texts.areYouSureReject);
    }

    markAsRead(ids) {
        //console.log('clicked');

        $.ajax({
            url: "/notifications/read/",
            dataType: 'json',
            method: 'post',
            data: {
                notifications: ids
            },
            success: function(data) {
                //console.log(data);
                if (data.status) {
                    if (data.unreadNotificationsCount == 0)
                        $(".header-notifications-count").hide();
                    $(".header-notifications-count").html(data.unreadNotificationsCount);
                }
            }
        });

    }

    acceptCohost(eventId, id, inviterId) {
        // $.ajax({
        //     url: "/event/verify-cohost/",
        //     dataType: 'json',
        //     method: 'post',
        //     data: {
        //         id: eventId,
        //         cohostId: id,
        //         inviterId: inviterId
        //     },
        //     success: function(data) {
        //         //console.log(data);
        //         if (data.success) {
        //             $('a[name="cohost-' + id + '"]').siblings('span').remove();
        //             $('a[name="cohost-' + id + '"]').remove();
        //         }
        //         $(".header-notifications-count").text($(".header-notifications-count").text() - 1);
        //         if ($(".header-notifications-count").text() == 0)
        //             $(".header-notifications-count").text();
        //     }
        // });
    }

    rejectCohost(eventId, id, inviterId) {
        // $.ajax({
        //     url: "/event/reject-cohost/",
        //     dataType: 'json',
        //     method: 'post',
        //     data: {
        //         id: eventId,
        //         cohostId: id,
        //         inviterId: inviterId
        //     },
        //     success: function(data) {
        //         //console.log(data);
        //         if (data.success) {
        //             $('a[name="cohost-' + id + '"]').siblings('span').remove();
        //             $('a[name="cohost-' + id + '"]').remove();
        //         }
        //         $(".header-notifications-count").text($(".header-notifications-count").text() - 1);
        //         if ($(".header-notifications-count").text() == 0)
        //             $(".header-notifications-count").text();
        //     }
        // })
    }
}

export { Notification }
